import { createLogic } from "redux-logic";
import Client from "../../../data/client";
import { updateTimezones } from "../actions";
import { CANCEL_GET_TIMEZONES, GET_TIMEZONES } from "../types";
var GetTimezonesLogic = createLogic({
    type: GET_TIMEZONES,
    cancelType: CANCEL_GET_TIMEZONES,
    latest: true,
    process: function (_a, dispatch, done) {
        var getState = _a.getState, action = _a.action;
        var url = "Utilities/Timezones";
        Client.get(url)
            .then(function (_a) {
            var data = _a.data;
            dispatch(updateTimezones(data));
        })
            .catch(function (error) {
            console.log("GetTimezonesLogic error", error);
        })
            .finally(function () {
            done();
        });
    },
});
var exportable = [GetTimezonesLogic];
export default exportable;
